import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

/*
 * FabricCartItems — the swatch grid shared by the cart page (editable)
 * and the checkout page (view-mode). Lee-project port.
 * Server-side rendered: ChakraCore rules — no ?. / ?? syntax.
 */
export default class FabricCartItems extends React.Component {

  qtyOptions = (item) => {
    // Per-type caps: fabric and finish samples have separate daily limits
    var max = item && item.itemType === "Finish"
      ? (this.props.maxFinish || 2)
      : (this.props.maxFabric || this.props.max || 10);
    var opts = [];
    for (var i = 1; i <= max; i++) opts.push(i);
    return opts;
  };

  onQuantityChange = (item, value) => {
    if (this.props.onQuantityChange) this.props.onQuantityChange(item, value);
  };

  onRemove = (e, item) => {
    e.preventDefault();
    if (this.props.onRemove) this.props.onRemove(item);
  };

  render() {
    var items = this.props.items || [];
    // imageRootUrl = image server root; item.image is folder-qualified
    var root = this.props.imageRootUrl || this.props.fabricsRootUrl || "";
    var disableEditing = this.props.disableEditing === true;
    var cls = "fabric-cart" + (disableEditing ? " view-mode" : "");

    if (items.length === 0) {
      return (
        <div className="fabric-cart-empty">
          <p>Your cart is empty. Browse our fabrics and finishes to add samples.</p>
        </div>
      );
    }

    return (
      <shopping-gallery class={cls}>
        {items.map((item) => {
          var detailUrl = item.itemType === "Finish"
            ? "/Custom-Option/Finish/Detail/" + encodeURIComponent(item.sku)
            : "/Custom-Option/Fabric/All/Detail/" +
              (item.name || item.sku).replace(/[^A-Za-z0-9]+/g, "-").replace(/^-+|-+$/g, "") +
              "/" + item.sku;
          return (
            <gallery-item key={item.sku}>
              {!disableEditing && (
                <button className="fabric-cart-remove" title="Remove"
                        onClick={(e) => this.onRemove(e, item)}>&times;</button>
              )}
              <a href={detailUrl} className="image-container">
                <img src={root + "/" + item.image} alt={item.name} className="gallery-item-image"
                     onError={(e) => { e.target.style.display = "none"; }} />
              </a>
              <div className="gallery-item-info">
                <a href={detailUrl} className="gallery-item-title">{item.name}</a>
                <span className="gallery-item-sku">{item.sku}</span>
                {item.grade ? <span className="gallery-item-grade">GRADE: {item.grade}</span> : null}
                {disableEditing ? (
                  <span className="gallery-item-grade">QTY: {item.quantity}</span>
                ) : (
                  <div className="fabric-cart-qty">
                    <label>QTY</label>
                    <DropDownList
                      data={this.qtyOptions(item)}
                      value={item.quantity}
                      onChange={(e) => this.onQuantityChange(item, e.target.value)}
                      style={{ width: "80px" }}
                    />
                  </div>
                )}
              </div>
            </gallery-item>
          );
        })}
      </shopping-gallery>
    );
  }
}
